var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCharity = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Donation-Charity-Hand-Receive-Heart-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Donation Charity Hand Receive Heart 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.63 4A3.54 3.54 0 0 0 17 3l-0.48 0.48L16 3a3.54 3.54 0 0 0 -5.63 1A3.51 3.51 0 0 0 11 8l5.11 5.34a0.51 0.51 0 0 0 0.72 0L22 8a3.53 3.53 0 0 0 0.63 -4Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94 16.06a3.92 3.92 0 0 0 -1.78 0.42L0.14 18a0.24 0.24 0 0 0 -0.14 0.22v5.4a0.23 0.23 0 0 0 0.13 0.21 0.23 0.23 0 0 0 0.25 0l3.42 -2.15a0.48 0.48 0 0 1 0.42 -0.05c10.26 3.44 6.78 3.5 18.11 -2.23a0.51 0.51 0 0 0 0.08 -0.86 2.45 2.45 0 0 0 -2.41 -0.48l-3.42 1.13a0.48 0.48 0 0 0 -0.29 0.25 2 2 0 0 1 -1.79 1.12h-4a0.5 0.5 0 0 1 -0.5 -0.5 0.5 0.5 0 0 1 0.5 -0.5h4a1 1 0 1 0 0 -2h-3.33a0.54 0.54 0 0 1 -0.3 -0.1A6.92 6.92 0 0 0 7 16.06Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCharity);
export default ForwardRef;